export default function PlaceholderImage(isFeatured?: boolean) {
  const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL ?? "/";
  const placeholder = `${BASE_URL}images/placeholder-image.png`;
  const placeholderFeatured = `${BASE_URL}images/featured-image.png`;

  return isFeatured
    ? {
        src: placeholderFeatured,
        altText: "Isovalent",
        alt: "Isovalent",
      }
    : {
        src: placeholder,
        altText: "Placeholder",
        alt: "Placeholder",
      };
}
